import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Role } from '../../../../../common/constants';
import { AuthFacade } from '../../../../../store/state/auth';
import { UserItemFacade, UserRoleType, UserRolesModel } from '../../../../../store/state/administration';
import { AutoUnsubscribe } from '../../../../../common/decorators';
import { ButtonAction, ButtonType } from '../../../../action-button';
import { UntypedFormControl, Validators } from '@angular/forms';

@Component({
  selector: 'user-roles-filters-dialog',
  templateUrl: './user-roles-filter-dialog.component.html',
  styleUrls: ['./user-roles-filter-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
@AutoUnsubscribe
export class UserRolesFilterDialogComponent implements OnInit {
  allRolesControl = new UntypedFormControl('', [Validators.required]);
  buttonAction = ButtonAction;
  buttonType = ButtonType;
  roles: UserRolesModel;

  constructor(
    public userItemFacade: UserItemFacade,
    public dialogRef: MatDialogRef<UserRolesFilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { roles: UserRolesModel; selectedRoles: UserRolesModel },
    public authFacade: AuthFacade,
  ) {}

  ngOnInit(): void {
    this.roles = this.data.roles;
  }

  changeRoles({ value }: { value: string }): void {
    const [groupKey, role] = value.split(':');
    this.allRolesControl.reset();
    this.allRolesControl.setValue({ [groupKey]: [role] });
  }

  isRoleChecked(parentKey: UserRoleType | string, role: Role): boolean {
    if (this.data.selectedRoles) {
      return this.data.selectedRoles[parentKey]?.includes(role);
    } else {
      return false;
    }
  }

  confirm(): void {
    this.dialogRef.close(this.allRolesControl.value);
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
